import TagTypes from './types';

export default function (singularSearch) {
  for (const [singular, plural] of TagTypes) {
    if (singularSearch === singular) {
      return plural;
    }
  }
}
